<template>
  <button
    class="datepicker-button"
    :class="{
      'active': active,
      'isCurrent': isCurrentDate,
      'disabled': disabled,
      'other-month': !currentMonth
    }"
    v-text="text"
    @click="clicked"
  >
  </button>
</template>

<script>
  export default {
    name: 'DatepickerButton',
    data () {
      return {
      }
    },
    props: {
      text: {
        default: '',
        type: String
      },
      currentMonth: {
        default: false,
        type: Boolean
      },
      disabled: {
        default: false,
        type: Boolean
      },
      isCurrentDate: {
        default: false,
        type: Boolean
      },
      forcedActive: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      active () {
        let self = this
        return self.forcedActive
      }
    },
    methods: {
      clicked () {
        let self = this
        if (!self.disabled) {
          self.$emit('clicked')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  .datepicker-button {
    background-color: #ffffff;
    color: $darkGreyFont;
    font-weight: 400;
    font-family: 'Roboto';
    padding: 0;
    transition-duration: 0.2s;

    border-radius: 50%;
    margin: auto;

    &:hover {
      color: $darkGreyFont;
      background-color: $mediumGreyBackground;
    }
    &.active {
      color: #ffffff;
      background-color: $pendingBlue;
    }
    &.other-month {
      color: $lightGreyFont;
      background-color: white;
    }
    &.isCurrent{
      color: $pendingBlue;
      background-color: #ffffff;
    }
    &.disabled {
      color: $lightGreyFont;
      background-color: white;
      cursor: default;
    }
    &.active.isCurrent{
      color: #ffffff;
      background-color: $pendingBlue;
    }

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/buttontemplates/DatepickerButton.vue